/* TRATHAM — Header: estado sólido/transparente, painéis do menu (desktop) e menu em tela cheia (mobile). */
if (!customElements.get('tr-header')) {
  class TrHeader extends HTMLElement {
    connectedCallback() {
      this.transparent = this.dataset.transparent === 'true';
      this.menu = this.querySelector('[data-menu]');
      this.openBtn = this.querySelector('[data-menu-open]');
      this.triggers = [...this.querySelectorAll('[data-mega-trigger]')];
      this.activeTrigger = null;
      this.closeTimer = null;
      this.desktop = window.matchMedia('(min-width: 1068px)');

      this.onScroll = this.onScroll.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.addEventListener('keydown', this.onKeydown);
      this.onScroll();

      this.setupMega();
      this.setupMenu();
      this.desktop.addEventListener('change', () => {
        this.closeMenu();
        this.closeMega();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKeydown);
    }

    updateSolid() {
      const solid = !this.transparent || window.scrollY > 8 || this.activeTrigger !== null;
      this.classList.toggle('is-solid', solid);
      this.classList.toggle('is-scrolled', window.scrollY > 120);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.updateSolid();
        this.ticking = false;
      });
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      if (this.menu && !this.menu.hidden && this.menu.classList.contains('is-sub')) {
        this.closeSub();
      } else if (this.menu && !this.menu.hidden) {
        this.closeMenu();
        this.openBtn?.focus();
      } else if (this.activeTrigger) {
        const trigger = this.activeTrigger;
        this.closeMega();
        trigger.focus();
      }
    }

    /* Painéis do menu ------------------------------------------------------ */
    setupMega() {
      this.triggers.forEach((trigger) => {
        const panel = this.querySelector('#' + trigger.getAttribute('aria-controls'));
        if (!panel) return;
        trigger.addEventListener('click', () => {
          trigger.getAttribute('aria-expanded') === 'true' ? this.closeMega() : this.openMega(trigger, panel);
        });
        trigger.addEventListener('mouseenter', () => {
          clearTimeout(this.closeTimer);
          this.openTimer = setTimeout(() => this.openMega(trigger, panel), 120);
        });
        trigger.addEventListener('mouseleave', () => {
          clearTimeout(this.openTimer);
          this.scheduleClose();
        });
        panel.addEventListener('mouseenter', () => clearTimeout(this.closeTimer));
        panel.addEventListener('mouseleave', () => this.scheduleClose());
      });
      this.querySelectorAll('.tr-header__nav-link:not([data-mega-trigger])').forEach((link) => {
        link.addEventListener('mouseenter', () => this.scheduleClose(80));
      });
      document.addEventListener('click', (event) => {
        if (this.activeTrigger && !this.contains(event.target)) this.closeMega();
      });
    }

    scheduleClose(delay = 220) {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closeMega(), delay);
    }

    openMega(trigger, panel) {
      if (!this.desktop.matches) return;
      if (this.activeTrigger === trigger) return;
      this.closeMega(true);
      this.activeTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      requestAnimationFrame(() => panel.classList.add('is-open'));
      this.classList.add('has-mega');
      this.updateSolid();
    }

    closeMega(immediate = false) {
      if (!this.activeTrigger) return;
      const trigger = this.activeTrigger;
      const panel = this.querySelector('#' + trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', 'false');
      this.activeTrigger = null;
      this.classList.remove('has-mega');
      if (panel) {
        panel.classList.remove('is-open');
        if (immediate) panel.hidden = true;
        else setTimeout(() => { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 360);
      }
      this.updateSolid();
    }

    /* Menu em tela cheia ---------------------------------------------------- */
    setupMenu() {
      if (!this.menu) return;
      this.openBtn?.addEventListener('click', () => this.openMenu());
      this.menu.querySelectorAll('[data-menu-close]').forEach((btn) => btn.addEventListener('click', () => this.closeMenu()));
      this.menu.querySelectorAll('[data-menu-close-on-click]').forEach((el) => el.addEventListener('click', () => this.closeMenu()));
      /* TRATHAM: 2º nível do menu mobile (ex.: Produtos) com retorno ao nível principal — 2026-10-20 */
      this.menu.querySelectorAll('[data-submenu-open]').forEach((btn) => btn.addEventListener('click', () => this.openSub(btn)));
      this.menu.querySelectorAll('[data-submenu-close]').forEach((btn) => btn.addEventListener('click', () => this.closeSub()));
      this.menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.menu.querySelectorAll('a, button, summary')].filter((el) => el.offsetParent !== null);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }

    openSub(btn) {
      const sub = this.menu.querySelector('#' + btn.getAttribute('aria-controls'));
      if (!sub) return;
      this.subTrigger = btn;
      btn.setAttribute('aria-expanded', 'true');
      sub.hidden = false;
      this.menu.classList.add('is-sub');
      this.menu.scrollTop = 0;
      requestAnimationFrame(() => { sub.classList.add('is-open'); sub.querySelector('[data-submenu-close]')?.focus(); });
    }

    closeSub(restoreFocus = true) {
      const sub = this.menu?.querySelector('[data-submenu]:not([hidden])');
      if (!sub) return;
      sub.classList.remove('is-open');
      sub.hidden = true;
      this.menu.classList.remove('is-sub');
      this.subTrigger?.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.subTrigger?.focus();
    }

    openMenu() {
      this.menu.hidden = false;
      this.openBtn?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('tr-menu-open');
      requestAnimationFrame(() => {
        this.menu.classList.add('is-open');
        this.menu.querySelector('[data-menu-close]')?.focus();
      });
    }

    closeMenu() {
      if (!this.menu || this.menu.hidden) return;
      this.closeSub(false);
      this.menu.classList.remove('is-open');
      this.openBtn?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('tr-menu-open');
      setTimeout(() => { if (!this.menu.classList.contains('is-open')) this.menu.hidden = true; }, 360);
    }
  }
  customElements.define('tr-header', TrHeader);
}

